export default "__VITE_ASSET__hQitepZ4__"